import { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import { getKmlImportErrorMessage } from '@/utils/Files/kmlImportErrors'
import { customSnackbarError } from './Snackbar'

export function useCustomSnackbarError(defaultErrorMessage = 'Ocurrió un error inesperado.') {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const handleError = useCallback(
    (error, customMessage, retryError = true) => {
      // Untagged errors keep falling through to error.message so every existing call site
      // renders exactly what it renders today.
      const base =
        customMessage ||
        getKmlImportErrorMessage(error) ||
        (error && error.message) ||
        defaultErrorMessage
      const message = `${base} ${retryError ? ' Por favor, intenta nuevamente.' : ''} `
      customSnackbarError(message, error, enqueueSnackbar, closeSnackbar)
    },
    [defaultErrorMessage, enqueueSnackbar, closeSnackbar],
  )

  return { handleError }
}
